import { useIntl } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'

import FormatCurrency from 'components/Common/FormatCurrency'
import LineAngleRightIcon from 'LuxKit/Icons/line/LineAngleRightIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import ListItemThumbnail from 'LuxKit/List/ListItemThumbnail'
import TripPlanBrowseRow from './TripPlanBrowseRow'
import type { HotelTilePrice } from '../hooks/useTripPlanHotelTileData'

const HOTEL_TILE_ICON_BACKGROUND = 'rgba(110, 79, 230, 0.2)'
const HOTEL_TILE_ICON_COLOUR = '#6E4FE6'

const HotelThumbnail = styled(ListItemThumbnail)`
  width: ${rem(40)};
  height: ${rem(40)};
  border-radius: ${rem(10)};

  &&& {
    background-color: ${HOTEL_TILE_ICON_BACKGROUND};
    color: ${HOTEL_TILE_ICON_COLOUR};
  }

  svg {
    width: ${rem(16)};
    height: ${rem(16)};
  }
`

interface Props {
  hotelTilePrice?: HotelTilePrice
  onOpen: () => void
}

function TripPlanHotelTile({
  hotelTilePrice,
  onOpen,
}: Props) {
  const intl = useIntl()

  const hotelTilePriceLabel = hotelTilePrice === undefined ? undefined : intl.formatMessage(
    {
      id: 'BW9zGX4U8wuVNhip8PV5',
      defaultMessage: 'From {price}/night',
      description: 'Per-night hotel price copy shown on the trip planner stop hotel tile',
    },
    { price: <FormatCurrency value={hotelTilePrice.price} currency={hotelTilePrice.currency} format="roundedDollar" /> },
  )

  const hotelActionsLabel = intl.formatMessage({
    id: 'rJwViybkCxy7xhl9jleU',
    defaultMessage: 'Browse hotel offers',
    description: 'Visible heading on the hotel offers tile and accessible label for the button that opens hotel search',
  })

  return (
    <TripPlanBrowseRow
      size="medium"
      titleWeight="bold"
      title={hotelActionsLabel}
      subtitle={hotelTilePriceLabel}
      onClick={onOpen}
      startIcon={<HotelThumbnail kind="highlight-secondary" gutter="none"><LineBedIcon size="XS" /></HotelThumbnail>}
      endIcon={<LineAngleRightIcon size="S" />}
    />
  )
}

export default TripPlanHotelTile
